/* Grid Lock Floors collection page: floor calculator, filters, sort, compare (7-10-2026) */
(function () {
  var root = document.querySelector('[data-glc]');
  if (!root) return;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var fmt = root.getAttribute('data-money') || '£{{amount}}';
  var rampPrice = parseInt(root.getAttribute('data-ramp'), 10) || 0;
  function money(c) {
    var amt = (Math.round(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amt).replace(/<[^>]+>/g, '');
  }
  function trim(n) { return String(Math.round(n * 100) / 100); }

  var grid = $('[data-glc-grid]');
  var cards = $$('[data-glc-card]');
  var S = { len: 5, wid: 2.5, ramps: false, th: 'all', joint: 'all', disc: false, sort: 'featured' };
  var lenIn = $('[data-glc-len]'), widIn = $('[data-glc-wid]'), rampIn = $('[data-glc-ramps]');

  function dims() {
    var cols = Math.max(1, Math.ceil(S.wid / 0.5 - 1e-9));
    var rows = Math.max(1, Math.ceil(S.len / 0.5 - 1e-9));
    return { cols: cols, rows: rows, tiles: cols * rows };
  }

  function drawPreview(d) {
    var g = $('[data-glc-prev]');
    if (!g) return;
    // length runs left to right, the door (width) is the bottom edge
    var across = d.rows, deep = d.cols;
    var scale = Math.min(112 / across, 76 / deep);
    g.style.width = Math.max(8, Math.round(across * scale)) + 'px';
    g.style.height = Math.max(8, Math.round(deep * scale)) + 'px';
    g.style.backgroundSize = (100 / across) + '% ' + (100 / deep) + '%';
    g.style.borderBottomWidth = S.ramps ? '6px' : '2px';
    g.style.borderBottomColor = S.ramps ? '#FFC928' : '';
  }

  function calc() {
    var d = dims();
    var area = d.tiles / 4;
    $$('[data-glc-tiles]', document).forEach(function (e) { e.textContent = d.tiles; });
    var dimTxt = trim(S.len) + ' × ' + trim(S.wid) + 'm';
    $$('[data-glc-dimt]', document).forEach(function (e) { e.textContent = dimTxt; });
    var dl = $('[data-glc-dims]');
    if (dl) dl.textContent = d.rows + ' × ' + d.cols + ' · ' + trim(area) + ' m²';
    var rn = $('[data-glc-rampn]'); if (rn) rn.textContent = d.cols;
    var door = $('[data-glc-door]'); if (door) door.textContent = trim(S.wid);
    drawPreview(d);
    cards.forEach(function (c) {
      if (c.getAttribute('data-tile') !== 'true') return;
      var p = parseInt(c.getAttribute('data-price'), 10) || 0;
      var tot = p * d.tiles;
      var addR = S.ramps && rampPrice && c.getAttribute('data-th10') === 'true';
      if (addR) tot += rampPrice * d.cols;
      var txt = (c.getAttribute('data-varies') === 'true' ? 'from ' : '') + money(tot);
      c.setAttribute('data-total', txt);
      var t = $('[data-glc-total]', c); if (t) t.textContent = txt;
      var rn2 = $('[data-glc-rnote]', c); if (rn2) rn2.textContent = addR ? ' + ' + d.cols + ' ramps' : '';
      var td = $('[data-glc-ttotal="' + c.getAttribute('data-idx') + '"]');
      if (td) td.textContent = txt;
    });
    drawBar();
  }

  function num(v) { var n = parseFloat(String(v).replace(',', '.')); return isFinite(n) && n > 0 ? Math.min(100, Math.max(0.5, Math.round(n * 10) / 10)) : null; }
  if (lenIn) lenIn.addEventListener('input', function () { var n = num(lenIn.value); if (n) { S.len = n; calc(); } });
  if (widIn) widIn.addEventListener('input', function () { var n = num(widIn.value); if (n) { S.wid = n; calc(); } });
  [lenIn, widIn].forEach(function (el) { if (el) el.addEventListener('change', function () { el.value = el === lenIn ? S.len : S.wid; }); });
  if (rampIn) rampIn.addEventListener('change', function () { S.ramps = rampIn.checked; calc(); });
  $$('[data-glc-pre]').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = b.getAttribute('data-glc-pre').split(',');
      S.len = parseFloat(v[0]); S.wid = parseFloat(v[1]);
      if (lenIn) lenIn.value = S.len; if (widIn) widIn.value = S.wid;
      calc();
    });
  });

  function byRank(a, b) { return (a.dataset.rank - b.dataset.rank) || (a.dataset.idx - b.dataset.idx); }
  // show ranges in the shop's chosen order, cards and table columns alike
  (function orderTable() {
    var t = $('[data-glc-tbl]');
    if (!t) return;
    var order = cards.slice().sort(byRank).map(function (c) { return c.getAttribute('data-idx'); });
    $$('tr', t).forEach(function (tr) {
      order.forEach(function (i) { var cell = tr.querySelector('[data-col="' + i + '"]'); if (cell) tr.appendChild(cell); });
    });
  })();

  function apply() {
    var shown = 0;
    cards.forEach(function (c) {
      var ok = (S.th === 'all' || (' ' + c.getAttribute('data-th') + ' ').indexOf(' ' + S.th + ' ') > -1) &&
        (S.joint === 'all' || c.getAttribute('data-joint') === S.joint) &&
        (!S.disc || c.getAttribute('data-disc') === 'true');
      c.hidden = !ok;
      if (ok) shown++;
    });
    var sh = $('[data-glc-shown]'); if (sh) sh.textContent = shown;
    var none = $('[data-glc-none]'); if (none) none.hidden = shown > 0;
    $$('[data-glc-f]').forEach(function (b) {
      var on = S[b.getAttribute('data-glc-f')] === b.getAttribute('data-v');
      b.classList.toggle('on', on); b.setAttribute('aria-pressed', on);
    });
    var db = $('[data-glc-disc]'); if (db) { db.classList.toggle('on', S.disc); db.setAttribute('aria-pressed', S.disc); }
    if (grid) {
      var list = cards.slice();
      if (S.sort === 'low') list.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
      else if (S.sort === 'high') list.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
      else list.sort(byRank);
      var keep = $('[data-glc-keep]', grid);
      list.forEach(function (c) { grid.insertBefore(c, keep || null); });
    }
  }
  $$('[data-glc-f]').forEach(function (b) { b.addEventListener('click', function () { S[b.getAttribute('data-glc-f')] = b.getAttribute('data-v'); apply(); }); });
  var discB = $('[data-glc-disc]'); if (discB) discB.addEventListener('click', function () { S.disc = !S.disc; apply(); });
  var sortS = $('[data-glc-sort]'); if (sortS) sortS.addEventListener('change', function () { S.sort = sortS.value; apply(); });
  var reset = $('[data-glc-reset]'); if (reset) reset.addEventListener('click', function () { S.th = 'all'; S.joint = 'all'; S.disc = false; apply(); });
  $$('[data-glc-show]').forEach(function (b) {
    b.addEventListener('click', function () {
      S.th = b.getAttribute('data-glc-show'); S.joint = 'all'; S.disc = false; apply();
      var bar = $('.glc-bar'); (grid || bar).scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // compare: up to 3 picks, highlighted in the table and listed in a bar at the bottom of the screen
  var tbl = $('[data-glc-tbl]');
  var picked = [];
  var bar = null;
  function drawTable() {
    if (!tbl) return;
    var many = cards.length > 5;
    $$('[data-col]', tbl).forEach(function (cell) {
      var i = cell.getAttribute('data-col');
      var on = picked.indexOf(i) > -1;
      cell.classList.toggle('cmp', on);
      cell.hidden = many && (picked.length ? !on : parseInt(i, 10) > 4);
    });
    var hint = $('[data-glc-thint]');
    if (hint) hint.textContent = picked.length ? 'Your picks are highlighted.' : 'Tap Compare on any card to highlight it here.';
  }
  function toggle(i) {
    var k = picked.indexOf(i);
    if (k > -1) picked.splice(k, 1);
    else { if (picked.length >= 3) picked.shift(); picked.push(i); }
    cards.forEach(function (c) {
      var on = picked.indexOf(c.getAttribute('data-idx')) > -1;
      c.classList.toggle('cmp', on);
      var b = $('[data-glc-cmp]', c);
      if (b) { b.setAttribute('aria-pressed', on); b.textContent = on ? 'Comparing' : 'Compare'; }
    });
    drawTable();
    drawBar();
  }
  function drawBar() {
    if (!tbl) return;
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'glc-cmpbar';
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'Compare');
      root.appendChild(bar);
    }
    if (!picked.length) { bar.hidden = true; bar.innerHTML = ''; return; }
    bar.hidden = false;
    var html = '<div class="glf-w"><strong>Compare side by side</strong><div class="glc-cmpbar__l">';
    picked.forEach(function (i) {
      var c = $('[data-glc-card][data-idx="' + i + '"]');
      if (!c) return;
      var nm = ($('h3', c) || {}).textContent || '';
      var tot = c.getAttribute('data-total');
      var esc = function (s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); };
      html += '<span>' + esc(nm.trim()) + (tot ? ' · ' + esc(tot) : '') + '<button type="button" data-glc-unpick="' + i + '" aria-label="Remove ' + esc(nm.trim()) + ' from compare">×</button></span>';
    });
    html += '</div><span class="glc-cmpbar__h">' + (picked.length < 2 ? 'Pick one more range to compare (up to 3).' : picked.length + ' ranges highlighted in the table below.') + '</span>';
    html += '<a class="glf-btn glf-btn-y" href="#compare">See the table</a></div>';
    bar.innerHTML = html;
    $$('[data-glc-unpick]', bar).forEach(function (b) { b.addEventListener('click', function () { toggle(b.getAttribute('data-glc-unpick')); }); });
  }
  $$('[data-glc-cmp]').forEach(function (b) {
    b.addEventListener('click', function () { toggle(b.getAttribute('data-glc-cmp')); });
  });

  calc();
  apply();
  drawTable();
})();
